import React from 'react';
import './TodosLoading.css';

export function TodosLoading() {
  return (
    <li className='TodosLoading'>
      <div className='TodosLoading__Loader'></div>
      <p className='TodosLoading__Text'>Loading To-Dos...</p>
    </li>
  )
}